import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const DiscountIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M23 12.46L20.56 9.68L20.9 6L17.29 5.18L15.4 2L12 3.46L8.6 2L6.71 5.18L3.1 5.99L3.44 9.67L1 12.46L3.44 15.24L3.1 18.93L6.71 19.75L8.6 22.93L12 21.46L15.4 22.92L17.29 19.74L20.9 18.92L20.56 15.24L23 12.46ZM18.49 14.57L18.75 17.36L16.01 17.98L14.58 20.39L12 19.28L9.42 20.39L7.99 17.98L5.25 17.36L5.51 14.56L3.66 12.46L5.51 10.34L5.25 7.56L7.99 6.95L9.42 4.54L12 5.64L14.58 4.53L16.01 6.94L18.75 7.56L18.49 10.35L20.34 12.46L18.49 14.57Z"
            fill="#222"
          />
          <path
            d="M15.2994 8.22792L16.5851 9.51364 9.51361 16.5851 8.22789 15.2994 15.2994 8.22792zM10.8928 8.96442C11.4254 9.49698 11.4254 10.3604 10.8928 10.893 10.3603 11.4256 9.4968 11.4256 8.96424 10.893 8.43167 10.3604 8.43167 9.49698 8.96424 8.96442 9.4968 8.43185 10.3603 8.43185 10.8928 8.96442zM16.0357 14.1072C16.5683 14.6398 16.5683 15.5033 16.0357 16.0358 15.5031 16.5684 14.6397 16.5684 14.1071 16.0358 13.5745 15.5033 13.5745 14.6398 14.1071 14.1072 14.6397 13.5747 15.5031 13.5747 16.0357 14.1072z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
